// src/components/wallets/BaseWallet.tsx
import React, { ReactElement } from 'react'
import Box from '@/components/boxes/Box'
import { PersonalWallet } from '@/database/personalwallet'
import { uni1d800 } from '@/utils/extras'
import { VaultWallet } from '@/database/vaultwallet'
import Link from 'next/link'
import { urlFromAddress } from '@/utils/shortenAddress'
import { GoLinkExternal } from 'react-icons/go'

interface BaseWalletProps {
    wallet: PersonalWallet | VaultWallet
    title: string
}

const BaseWallet = React.memo(({ wallet, title }: BaseWalletProps): ReactElement => {
    return (
        <div className="header-container center">
            <div className="artwork-box center width-hundred max-width-370 margin-box">
                <div className={'header-container gradient-text bold large-bold bottom'}>
                    <Box caption={title} text={''} styleCaption={'gradient-text bold large-bold'} />
                </div>
                <div className={'nav__balances header-container bottom'}>
                    <Box
                        caption={'\uD836\uDE17CRAZY\u200C\uD836\uDE17'}
                        styleCaption={uni1d800.className + ' center small'}
                        styleText={'center'}
                        text={wallet.tokenBalances[0] ? wallet.tokenBalances[0].balance : '0'}
                    />
                    <Box
                        caption={'PLS'}
                        styleCaption={uni1d800.className + ' center small'}
                        styleText={'center'}
                        text={wallet.pulse}
                    />
                    <Box
                        caption={
                            <Link
                                href={urlFromAddress(wallet.address)}
                                className={'z-index-hundred'}
                                target="_blank"
                                rel="noopener noreferrer"
                                passHref={true}
                            >
                                <GoLinkExternal className="social-media-icon margin-top-five gray " />
                            </Link>
                        }
                        styleCaption={uni1d800.className + ' center small'}
                        styleText={'center'}
                        text={
                            <Link
                                href={urlFromAddress(wallet.address)}
                                className={'z-index-hundred'}
                                target="_blank"
                                rel="noopener noreferrer"
                                passHref={true}
                            >
                                Tokens &amp; NFT&apos;s
                            </Link>
                        }
                    />
                </div>
            </div>
        </div>
    )
})

BaseWallet.displayName = 'BaseWallet'

export default BaseWallet
